<template>
  <b-modal id="idModalHistoryCarrier" size="xl" hide-footer centered title="Historial Carrier">
    <b-table striped hover :items="items" :fields="fields" :small="true" :fixed="true"></b-table>
  </b-modal>
</template>
<script>
export default {
  props: ['integration'],
  computed: {
    fields() {
      return this.integration && this.integration.length > 0 ? this.integration[0] : []
    },
    items() {
      return this.integration && this.integration.length > 1 ? this.integration.slice(1).map(el => {
        const response = {}
        el.forEach((value, index) => {
          response[this.fields[index]] = value
        })
        return response
      }) : []
    }
  }
}
</script>